import React from "react";
import ApiUrl from "./ApiUrl";

const CoursesUrl = ApiUrl + "courses/";

//courses/register

export const CreateCourseService = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${CoursesUrl}register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const UpdateCourseService = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${CoursesUrl}update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const DeleteCourse = (id) => {
   const service = `${CoursesUrl}delete`;
   const data = {idCourse: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListByEssential = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByEssential`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListAllCourses = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}list`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByPrime = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByPrime`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByEmblem = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByEmblem`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByCourseType = (id) => {
   // lista de todos los usuarios
   const service = `http://domecqapi.trebolbit.com/api/courses/listByCourseType`;
   const data = {idCourseType: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const SingleCourseService = (id) => {
   // lista de todos los usuarios
   const service = `http://domecqapi.trebolbit.com/api/courses/single_course`;
   const data = {idCourse: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListResourcesCourses = (idCourse) => {
   const service = `${ApiUrl}resources/listByCourse`;
   const data = {idCourse};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const DeleteResource = (idResource) => {
   const service = `${ApiUrl}resources/delete`;
   const data = {idResource, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListThemaryCourses = (idCourse) => {
   const service = `${ApiUrl}temaryClasses/list`;
   const data = {idCourse, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const DeleteThemaryCourses = (idTemaryClasses) => {
   const service = `${ApiUrl}temaryClasses/delete`;
   const data = {idTemaryClasses, token: localStorage.getItem("domecq_token")};

   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const DeleteSubclassCourses = (idTemarySubclasses) => {
   const service = `${ApiUrl}temarySubclasses/delete`;
   const data = {idTemarySubclasses, token: localStorage.getItem("domecq_token")};

   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const getTestimonialsService = (idCourse) => {
   const service = `${ApiUrl}testimonials/list`;
   return fetch(service);
};
export const getTestimonialsCourse = (idCourse) => {
   const service = `${ApiUrl}testimonials/listByCourse`;
   const data = {idCourse, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const CreateTestimonialService = (data) => {
   const service = `${ApiUrl}testimonials/register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const UpdateTestimonialService = (data) => {
   const service = `${ApiUrl}testimonials/update`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const DeleteTestimonialService = (idTestimonial) => {
   const service = `${ApiUrl}testimonials/delete`;
   const data = {idTestimonial, token: localStorage.getItem("domecq_token")};

   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
// list courses history
export const HistoryListUsers = (idCourse) => {
   const service = `${ApiUrl}courseHistory/listByCourse`;
   const data = {idCourse, token: localStorage.getItem("domecq_token")};

   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
